export default __webpack_public_path__ + "static/media/info-wifi.e9f1052b.gif";